import React, { useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import { CORE_PROPERTY_FIELDS } from '@general/graphql/fragments/property';
import { PROPERTY_CONTACTS_FIELDS } from '@general/graphql/fragments/property-contacts';

export const EDIT_PROPERTY = gql`
    ${CORE_PROPERTY_FIELDS}
    ${PROPERTY_CONTACTS_FIELDS}
    mutation EditProperty(
        $id: ID!
        $title: String
        $description: String
        $subpremiseId: String
        $url: String
        $location: String
        $listingStatus: ListingStatus
        $purpose: TenancyPurpose
        $density: TenancyDensity
        $squareFeet: Int
        $typeOfCenter: TenancyTypeOfCenter
        $typeOfFacility: TenancyTypeOfFacility
        $businesses: [BusinessInput]
    ) {
        updateProperty(
            id: $id
            title: $title
            description: $description
            subpremiseId: $subpremiseId
            url: $url
            location: $location
            listingStatus: $listingStatus
            purpose: $purpose
            density: $density
            squareFeet: $squareFeet
            typeOfCenter: $typeOfCenter
            typeOfFacility: $typeOfFacility
            businesses: $businesses
        ) {
            ...CorePropertyFields
            ...PropertyContactsFields
        }
    }
`;

const useEditProperty = ({ onCompleted, onError }) => {
    const [error, setError] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [updateMutate] = useMutation(EDIT_PROPERTY, {
        onCompleted: d => onComplete(d),
        onError: e => handleError(e),
    });

    const onComplete = d => {
        setIsLoading(false);
        setIsSuccessful(true);

        if (onCompleted) {
            onCompleted(d);
        }
    };

    const handleError = e => {
        setIsLoading(false);
        setError(e);
        if (onError) {
            onError();
        }
    };

    const editProperty = React.useCallback(
        async ({ variables }) => {
            setIsLoading(true);
            await updateMutate({
                variables,
            });
        },
        [updateMutate]
    );

    return { isLoading, error, editProperty, isSuccessful };
};

export default useEditProperty;
